// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const SW_CLEANUP_RELOAD_FLAG = "wizmate.sw-cleanup-reloaded";

async function cleanupLegacyServiceWorkers(): Promise<void> {
	if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
		return;
	}

	try {
		const registrations = await navigator.serviceWorker.getRegistrations();
		if (registrations.length === 0) {
			return;
		}

		await Promise.all(registrations.map((registration) => registration.unregister()));

		const alreadyReloaded = sessionStorage.getItem(SW_CLEANUP_RELOAD_FLAG) === "1";
		if (navigator.serviceWorker.controller && !alreadyReloaded) {
			sessionStorage.setItem(SW_CLEANUP_RELOAD_FLAG, "1");
			window.location.reload();
			return;
		}

		sessionStorage.removeItem(SW_CLEANUP_RELOAD_FLAG);
	} catch (error) {
		console.warn("[index] failed to cleanup service workers", error);
	}
}

void cleanupLegacyServiceWorkers();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// 起動処理（API呼び出し）をデバッグしやすくするため、開発中は StrictMode を外す。
// StrictMode は開発時に副作用を二重実行する挙動があり、起動処理の検証が混乱しやすい。
root.render(<App />);
